import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class DcProductNutritionFacts extends Component {
  requiredRefs = ['container'];

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateNutritionFacts);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateNutritionFacts);
  }

  /**
   * Updates the nutrition facts image when the variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateNutritionFacts = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `dc-product-nutrition-facts[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newElement) return;

    const newContainer = newElement.querySelector('[ref="container"]');
    if (newContainer && this.refs.container) {
      this.refs.container.replaceWith(newContainer);
    }
  };
}

if (!customElements.get('dc-product-nutrition-facts')) {
  customElements.define('dc-product-nutrition-facts', DcProductNutritionFacts);
}
